import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { alertSx, primaryButtonSx, textFieldSx } from './authFormStyles';

interface Props {
  onSubmit: (username: string, password: string) => void;
  loading: boolean;
  error: string | null;
}

export const SignInForm: React.FC<Props> = ({ onSubmit, loading, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const canSubmit = username.length > 0 && password.length > 0 && !loading;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit(username, password);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}
    >
      <Box component="div" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Box
          component="div"
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(199, 20, 68, 0.18) 0%, rgba(199, 20, 68, 0.08) 100%)',
            border: '1px solid rgba(199, 20, 68, 0.32)',
          }}
        >
          <LockOutlinedIcon sx={{ color: '#C71444', fontSize: 28 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500, letterSpacing: '0.02em' }}
        >
          サインイン
        </Typography>
      </Box>

      <TextField
        label="ユーザー名"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        autoComplete="username"
        autoFocus
        disabled={loading}
        fullWidth
        sx={textFieldSx}
      />
      <TextField
        label="パスワード"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="current-password"
        disabled={loading}
        fullWidth
        sx={textFieldSx}
      />
      {error && (
        <Alert severity="error" sx={alertSx}>
          {error}
        </Alert>
      )}
      <Button
        type="submit"
        variant="contained"
        disabled={!canSubmit}
        startIcon={loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : undefined}
        sx={primaryButtonSx}
        fullWidth
      >
        サインイン
      </Button>
    </Box>
  );
};
